export type MigrationFlowData = {
  policyNumber?: string;
  memberId?: string;
  memberType?: string;
  password?: string;
  loginId?: string;
  canModifyLoginId?: boolean;
  countryCode?: string;
  mobile?: string;
  terms?: boolean;
};

export const initialMigrationState: MigrationFlowData = {
  memberType: '0',
  canModifyLoginId: false,
  countryCode: '+852',
};
